/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import IconContractLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconContractLaw";
import IconRentalLaw from "@/src/assets/iconsRedesign2026/contract/toggleable/IconRentalLaw";
import IconTrafficLaw from "@/src/assets/iconsRedesign2026/traffic/toggleable/IconTrafficLaw";
import IconFamilyLaw from "@/src/assets/iconsRedesign2026/familyLaw/toggleable/IconFamilyLaw";
import IconEmploymentLaw from "@/src/assets/iconsRedesign2026/common/toggleable/IconEmploymentLaw";
import IconCivilLaw from "@/src/assets/iconsRedesign2026/civilLaw/toggleable/IconCivilLaw";

export const areasOfLawAccordionContent = [
  {
    icon: IconContractLaw,
    title: "Vertragsrecht",
    text: "Probleme mit dem Stromanbieter, beim Autokauf, mit Fake-Shops oder anderen Verträgen - Wir setzen Ihre Ansprüche durch!",
    link: "/vertragsrecht",
  },
  {
    icon: IconRentalLaw,
    title: "Mietrecht",
    text: "Ob als Mieter oder Vermieter – wir unterstützen Sie bei allen Fragen rund um Ihren Mietvertrag und setzen Ihre Rechte konsequent durch!",
    link: "/mietrecht",
  },
  {
    icon: IconTrafficLaw,
    title: "Verkehrsrecht",
    text: "Zu schnell gefahren, rote Ampel übersehen oder in einen Verkehrsunfall verwickelt worden? Wir kümmern uns für Sie darum!",
    link: "/verkehrsrecht",
  },
  {
    icon: IconFamilyLaw,
    title: "Familienrecht",
    text: "Scheidung, Unterhalt und alle anderen Themen im Familienrecht - wir begleiten Sie persönlich und finden auch in emotionalen Situationen klare Lösungen!",
    link: "/familienrecht",
  },
  {
    icon: IconEmploymentLaw,
    title: "Arbeitsrecht",
    text: "Ärger mit Ihrem Arbeitgeber oder der Behörde, für die Sie arbeiten? Wir unterstützen Sie bei allen Themen rund um Ihr Arbeitsverhältnis.",
    link: "/arbeitsrecht",
  },
  {
    icon: IconCivilLaw,
    title: "Allgemeines Zivilrecht",
    text: "Verleumdung, Unterlassung oder Schadenersatz – wir helfen Ihnen, Ihre Rechte im Alltag effektiv durchzusetzen!",
    link: "/allgemeines-zivilrecht",
  },
];
